var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 d-flex flex-column",class:{
    'align-items-end': _vm.chat.user_id === _vm.curBotId,
    'align-items-start': _vm.chat.user_id !== _vm.curBotId,
  }},[_c('div',{staticClass:"mt-1",class:{
      sent: _vm.chat.user_id === _vm.curBotId,
      received: _vm.chat.user_id !== _vm.curBotId,
    }},[(_vm.chat.media_path)?_c('ChatFile',{staticClass:"mb-2",attrs:{"media-path":_vm.chat.media_path}}):_vm._e(),_vm._v(" "+_vm._s(_vm.chat.message)+" ")],1),_c('div',{staticClass:"d-flex chat-time"},[_vm._v(" "+_vm._s(_vm.getCurrentChatTime(_vm.chat.created_on))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }